module.exports = __webpack_public_path__ + "static/media/bluelinkedin.ebb2ee8c.svg";